import { createStore } from 'zustand/vanilla';
var NavigationItems;
(function (NavigationItems) {
    NavigationItems["BURGER"] = "Burger";
    NavigationItems["SEARCH"] = "Search";
    NavigationItems["CART"] = "Cart";
})(NavigationItems || (NavigationItems = {}));
const getNavKey = (nav) => `is${nav}Open`;
const NavigationStore = createStore((set, get) => ({
    isBurgerOpen: false,
    isSearchOpen: false,
    isCartOpen: false,
    toggle: (nav) => set((state) => {
        const navKey = getNavKey(nav);
        NavigationStore.getState().closeAll();
        return Object.assign({ [navKey]: !state[navKey] });
    }),
    close: (nav) => set(() => {
        const navKey = getNavKey(nav);
        return { [navKey]: false };
    }),
    open: (nav) => set(() => {
        const navKey = getNavKey(nav);
        return { [navKey]: true };
    }),
    closeAll: () => set(() => Object.fromEntries(Object.values(NavigationItems).map((nav) => [getNavKey(nav), false]))),
    isActive: (nav) => {
        return get()[getNavKey(nav)];
    },
    hasActive: () => {
        return Object.values(NavigationItems).some((nav) => get()[getNavKey(nav)]);
    },
}));
export { getNavKey, NavigationItems, NavigationStore };
